import React from 'react';
import {
  addPathToList,
  Configure_transfer_confirmation,
  getSubCategoryId,
  Payment_confirmation,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';

//= ========================================================================
const Panel_G10_SplitPaymentConfirmation = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'does_it_look_ok',
    'confirm',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Payment_confirmation}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/confirmation_split/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/confirmation_split/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={Configure_transfer_confirmation}
      language={language}
      paragraphMarginBottom={30}
    />
  );
};

export default Panel_G10_SplitPaymentConfirmation;
